<template>
  <div class="page-effect">
    <!-- <section
      id="sectionId"
      class="ss-reg-top"
      style="background-color: #f1f3f4"
    > -->
    <div class="container-fluid border-bottom p-0">
      <div
        class="d-md-flex justify-content-between page-option-sticky ss-reg-top"
        v-if="!isRegistrationComponent && false"
      >
        <div>
          <a href="" class="d-flex justify-content-center align-items-center"
            ><v-icon color="#333" size="18px" class="mr-1"
              >mdi-arrow-left</v-icon
            >
            Back to Stage View</a
          >
        </div>
        <!-- <a
          href="#"
          class="pt-3 left-effect2"
          data-toggle="modal"
          data-target="#welcomemailModalCenter"
          @click="
            $refs.reminderAnnounceMailPopup.getMailTemplate('ReminderMail')
          "
        >
        <v-icon color="#1c1d26" size="25px">mdi-email-outline</v-icon> 
          Send Mail
        </a> -->
        <div>
          <a
            href="javascript:void(0);"
            class="pt-3 left-effect2 d-none"
            data-toggle="modal"
            data-target="#CheckoutformypeModal"
          >
            <v-icon color="#5a646e" size="18px" class="mr-1"
              >mdi-cog-outline</v-icon
            >
            Advanced Settings
          </a>
          <v-btn
            class="my-2 mr-4 save-standard d-none"
            outlined
            color="#2376e5"
            width="180px"
            @click="openAttendeePopup()"
            ><v-icon class="mr-1" color="#2376e5" size="20px">mdi-plus</v-icon>
            Add New Session</v-btn
          >
        </div>
      </div>
      <div>
        <!-- @onUpdate="onUpdate" -->
        <Sessions
          ref="sessionList"
          :key="sessionsListKey"
          :isAdminComponent="isAdminComponent"
          :isRegistrationComponent="isRegistrationComponent"
          @OpenAddSessionPopup="OpenAddSessionPopup"
        >
        </Sessions>
      </div>
    </div>
    <!-- </section> -->
    <!-- Add new Modal -->
    <SessionAddEdit
      v-if="sessionAddEditDialog"
      :key="sessionAddEditKey"
      :uid="uid"
      :clientId="clientId"
      :eventId="eventId"
      :event_collectionName="event_collectionName"
      :Attendee="Attendee"
      @OnAddSessionSuccess="OnAddSessionSuccess"
    ></SessionAddEdit>
    <!-- Add new Modal -->

    <div
      id="sessionAddEditSuccess"
      class="modal fade ss-success-modal"
      role="dialog"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <img src="../assets/Images/reg-ico/success.png" alt="e2m" />
            <h2 class="my-5">
              The new attendee has been created successfully!
            </h2>
            <div class="ss-cns-foo-btn">
              <button
                type="button"
                class="btn btn-primary px-4"
                @click="CloseSuccess"
              >
                Greate
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!----create new-session-popuop start------>
    <!-- The Modal -->
    <v-dialog
      v-if="sessionDialog"
      v-model="sessionDialog"
      width="1000"
      scrollable
    >
      <v-card>
        <!-- Modal Header -->
        <div class="register_popup">
          <div class="modal-header">
            <h4 class="modal-title page-head">
              {{ currentSessionId ? "Edit Session" : "Create New Session" }} -
              {{ createSessionTypeName }}
            </h4>
            <button type="button" class="close" @click="sessionDialog = false">
              &times;
            </button>
          </div>
        </div>
        <v-card-text>
          <!-- Modal body -->
          <v-form ref="form" v-model="validForm" lazy-validation>
            <div>
              <div class="ss-cns-body-wrap">
                <div
                  class="d-flex align-items-center client-stream mb-5"
                  v-if="session_data.SessionTypeDetails.TypeID == 3"
                >
                  <!-- <p>Streaming Client:</p> -->
                  <!-- <input
                    type="radio"
                    id="streamingClient"
                    name="radio-group"
                    v-model="session_data.streamingClient"
                  />
                  <label for="streamingClient">Zoom Client</label>
                  <span class="ss-info" data-toggle="tooltip" title="info Text">
                    <img src="../assets/Images/reg-ico/info.svg" alt="onair" />
                  </span>
                  <input type="radio" id="streamingClient-2" name="radio-group" />
                  <label for="streamingClient-2">Web</label>
                  <span class="ss-info" data-toggle="tooltip" title="info Text">
                    <img src="../assets/Images/reg-ico/info.svg" alt="onair" />
                  </span> -->
                  <!-- <div class="ml-3">
                    <v-radio-group v-model="session_data.StreamingClient" row>
                      <v-radio label="Zoom Client" value="Zoom"></v-radio>
                      <v-radio label="Zoom Web" value="ZoomWeb"></v-radio> 
                      <v-radio label="Web" value="Web"></v-radio>
                    </v-radio-group>
                  </div> -->
                </div>
                <div class="form-group">
                  <label>Session Title*</label>
                  <v-text-field
                    outlined
                    type="Text"
                    :rules="[(v) => !!v || 'This field is required']"
                    required
                    class="ss-cns-name"
                    placeholder="Enter Session Title"
                    v-model="session_data.Name"
                    counter
                    maxlength="200"
                  ></v-text-field>
                </div>
                <div class="form-group mb-0">
                  <label>Description (Optional)</label>
                  <v-textarea
                    solo
                    v-model="session_data.DescriptionShort"
                    counter
                    maxlength="2000"
                  ></v-textarea>

                  <!-- <textarea
                    type="Text"
                    class="form-control"
                    placeholder=""
                    cols="4"
                    rows="3"
                    v-model="session_data.DescriptionShort"
                    counter
                    maxlength="2000"
                  ></textarea> -->
                </div>
                <hr />
                <div class="row">
                  <div class="col-md-12 pr-1">
                    <div class="form-group d-flex justify-center">
                      <img
                        :src="session_data.SessionLogo"
                        style="width: 200px; height: 100px; background: #ccc"
                      />
                      <v-file-input
                        accept="image/png, image/jpeg, image/bmp"
                        label="Upload Logo"
                        filled
                        outlined
                        prepend-icon="mdi-camera"
                        class="ml-5 mt-5"
                        @change="
                          update_logo($event, '200x100', {
                            field: 'session_data',
                            key: 'SessionLogo',
                          })
                        "
                        @click:clear="resetSessionLogo()"
                      ></v-file-input>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Start on*</label>
                      <!-- <input
                        type="datetime-local"
                        class="form-control"
                        placeholder="Enter Session Title"
                      /> -->

                      <flat-pickr
                        :config="configdateTimePickerStart"
                        :rules="[(v) => !!v || 'This field is required']"
                        required
                        name="Starts On"
                        v-model="session_data.StartDate"
                        data-vv-validate-on="change"
                        placeholder="MM/DD/YYYY HH:MM"
                        class="time-pkr form-control"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Ends on*</label>
                      <!-- <input
                      type="datetime-local"
                      class="form-control"
                      placeholder="Enter Session Title"
                    /> -->
                      <flat-pickr
                        :config="configdateTimePickerEnd"
                        :rules="[(v) => !!v || 'This field is required']"
                        required
                        name="Ends On"
                        v-model="session_data.EndDate"
                        data-vv-validate-on="change"
                        placeholder="MM/DD/YYYY HH:MM"
                        class="time-pkr form-control"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-md-6"
                    v-if="session_data.SessionTypeDetails.TypeID == 3"
                  >
                    <div class="form-group">
                      <label>Select a Speaker*</label>
                      <v-select
                        label="Select"
                        outlined
                        :rules="[(v) => !!v || 'This field is required']"
                        required
                        v-model="session_data.MappedSpeakers"
                        :items="speakerList"
                        item-text="Name"
                        return-object
                        multiple
                      ></v-select>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    v-if="
                      [3, 5].includes(session_data.SessionTypeDetails.TypeID)
                    "
                  >
                    <div class="form-group">
                      <label>Select a Host*</label>
                      <v-select
                        outlined
                        label="Select"
                        :rules="[(v) => !!v || 'This field is required']"
                        required
                        v-model="session_data.MappedHosts"
                        :items="
                          session_data.MappedSpeakers.length
                            ? session_data.MappedSpeakers
                            : speakerList
                        "
                        item-text="Name"
                        return-object
                        multiple
                      ></v-select>
                    </div>
                  </div>
                  <!-- <div class="col-md-6">
                  <div class="form-group">
                    <label>Session Visible for*</label>
                    <select type="" class="form-control">
                      <option>List of attendees</option>
                      <option>A</option>
                      <option>b</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Select Attendees*</label>
                    <select type="" class="form-control">
                      <option>Floyd</option>
                      <option>Mario</option>
                    </select>
                  </div>
                </div> -->
                </div>
                <div
                  class="row"
                  v-if="session_data.SessionTypeDetails.TypeID == 4"
                >
                  <div class="col-md-12">
                    <h2>Round Table Mapping</h2>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <v-switch
                        v-model="session_data.MapExistingRoundTableGroup"
                        label="Map Existing Round Table Group"
                      ></v-switch>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    v-if="
                      session_data.SessionTypeDetails.TypeID == 4 &&
                      !session_data.MapExistingRoundTableGroup
                    "
                  >
                    <div class="form-group">
                      <v-radio-group
                        v-model="session_data.RTStreamingClient"
                        row
                      >
                        <v-radio label="Zoom Client" value="Zoom"></v-radio>
                        <v-radio label="Zoom Web" value="ZoomWeb"></v-radio>
                        <v-radio label="Web" value="Web"></v-radio>
                      </v-radio-group>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    v-if="
                      session_data.SessionTypeDetails.TypeID == 4 &&
                      !session_data.MapExistingRoundTableGroup
                    "
                  >
                    <div class="form-group">
                      <label>Select Round Table Host*</label>
                      <v-select
                        outlined
                        label="Select"
                        :rules="[(v) => !!v || 'This field is required']"
                        required
                        v-model="session_data.RTHost"
                        :items="attendeeList"
                        item-text="Name"
                        return-object
                      ></v-select>
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    v-if="
                      session_data.SessionTypeDetails.TypeID == 4 &&
                      !session_data.MapExistingRoundTableGroup
                    "
                  >
                    <div class="form-group">
                      <label>No of seats per Table*</label>
                      <v-text-field
                        outlined
                        v-model="session_data.NumberOfSeatsPerTable"
                        :rules="[(v) => !!v || 'This field is required']"
                        required
                        hide-details
                        type="number"
                        :min="MinNumberOfSeatsPerTable"
                        :max="MaxNumberOfSeatsPerTable"
                        step="1"
                      />
                    </div>
                  </div>
                  <div
                    class="col-md-6"
                    v-if="
                      session_data.SessionTypeDetails.TypeID == 4 &&
                      session_data.MapExistingRoundTableGroup
                    "
                  >
                    <div class="form-group">
                      <label>Map to Round Table Group*</label>
                      <v-select
                        outlined
                        label="Select"
                        :rules="[(v) => !!v || 'This field is required']"
                        required
                        v-model="session_data.RoundTables"
                        :items="roundtableGroupList"
                        item-text="TopicName"
                        return-object
                      ></v-select>
                    </div>
                  </div>
                </div>
                <!-- <div class="reg-page-tab-hld mt-4">
                <div class="d-flex align-items-center l-text reg-page-tab-hld">
                  Enable RTMP Stream
                  <label class="switch ml-3 mb-0"
                    ><input type="checkbox" checked="checked" /><span
                      class="slider round"
                    ></span>
                  </label>
                  <span class="ss-info" data-toggle="tooltip" title="info Text">
                    <img src="../assets/Images/reg-ico/info.svg" alt="onair" />
                  </span>
                </div>
              </div> -->
              </div>
            </div>
          </v-form>
        </v-card-text>

        <!-- Modal footer -->
        <v-divider class="m-0"></v-divider>
        <v-card-actions class="py-4">
          <v-spacer></v-spacer>
          <div class="">
            <v-btn
              color="#1c1d26"
              class="mr-2 cancel-standard"
              outlined
              @click="
                sessionDialog = false;
                $refs.form.resetValidation();
              "
              >Cancel</v-btn
            >
            <v-btn
              color="#1a73e8"
              class="save-standard"
              dark
              @click="createSession()"
              >Save</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!----create new-session-popuop end------>
  </div>
</template>
<script>
import { bus } from "@/main";
import APIs from "@/components/APIInit";
import store from "../store";
import axios from "axios";
import router from "../router";
import jQuery from "jquery";
let $ = jQuery;
import db from "../components/firebaseInit";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

import Sessions from "@/views/sessions.vue";
import SessionAddEdit from "@/views/SessionAddEdit.vue";

var vm;
//import Vue from "vue";
//import VueMoment from "vue-moment";
import moment from "moment-timezone";
// import axios from "axios";
// import { bus } from "@/main";
// Vue.use(VueMoment, {
//   moment,
// });

export default {
  components: {
    Sessions,
    SessionAddEdit,
    flatPickr,
  },
  props: {
    isRegistrationComponent: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      rtSeatRules: [
        (v) => !!v || "This field is required",
        (v) => (v && v <= 8) || "Max should not be above 8",
      ],
      validForm: true,
      uid: "",
      clientId: "",
      eventId: "",
      event_collectionName: "",
      isAdminComponent: true,
      sessionsListKey: 0,
      sessionAddEditKey: 0,
      sessionAddEditDialog: false,
      currentSessionId: 0,
      // BannerURL: "",
      // mobileBanner: "",
      // desktopBanner: "",
      Attendee: {},
      sessionDialog: false,
      radioGroup: 1,
      createSessionTypeId: null,
      createSessionTypeName: null,
      session_data: null,
      configdateTimePicker: {
        minDate: new Date(),
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y H:i",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: true,
        position: "above",
      },
      configdateTimePickerStart: {
        minDate: new Date(),
        maxDate: null,
        onChange: function (val) {
          if (val) vm.configdateTimePickerEnd.minDate = new Date(val);
        },
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
        position: "above",
      },
      configdateTimePickerEnd: {
        minDate: new Date(),
        maxDate: null,
        enableTime: true,
        enableSeconds: false,
        noCalendar: false,
        dateFormat: "m/d/Y h:i K",
        defaultHour: 24,
        defaultMinute: 0,
        time_24hr: false,
        position: "above",
      },
      configdateTimePickerTime: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true,
        time_24hr: true,
        position: "above",
      },
      speakerList: [],
      attendeeList: [],
      roundtableGroupList: [],
      MaxNumberOfSeatsPerTable: 12,
      MinNumberOfSeatsPerTable: 2,
    };
  },
  computed: {},
  watch: {
    "session_data.RTStreamingClient"(val) {
      if (val.includes("Zoom")) {
        this.MaxNumberOfSeatsPerTable = 300;
      } else {
        this.MaxNumberOfSeatsPerTable = 12;
      }
    },
  },
  created() {
    vm = this;
    this.getAllActiveSpeakers();
    this.getAllActiveAttendees();
    this.getAllRtTopic();
    //vm.initScreen();
    // $(window).resize(function () {
    //   vm.initScreen();
    // });
  },
  mounted() {
    vm.uid = vm.getSessionUserId();
    vm.clientId = vm.getClientId();
    vm.eventId = vm.getEventId();
    vm.event_collectionName = vm.getEventCollectionName();
    //vm.OpenSuccess();
  },
  methods: {
    // initScreen() {
    //   if (window.innerWidth > 768) {
    //     vm.BannerURL = vm.desktopBanner;
    //   } else {
    //     vm.BannerURL = vm.mobileBanner;
    //   }
    // },

    resetSessionLogo() {
      vm.session_data.SessionLogo =
        "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fon-air-white.png?alt=media";
    },
    goForLogin: function () {
      router.push({ name: "Login" });
    },
    async OpenAddSessionPopup(type, id) {
      vm.currentSessionId = id;
      vm.createSessionTypeId = type.typeId;
      vm.createSessionTypeName = type.typeName;
      let res = await vm.fetchSession(id).catch();
      if (res.status == 200 && res.data) {
        let eventStartTimestamp = vm.getEventStartDate().seconds;
        let eventEndTimestamp = vm.getEventEndDate().seconds;
        vm.configdateTimePickerStart.minDate = new Date(
          eventStartTimestamp * 1000
        );
        vm.configdateTimePickerEnd.minDate = new Date(
          eventStartTimestamp * 1000
        );
        vm.configdateTimePickerStart.maxDate = new Date(
          eventEndTimestamp * 1000
        );
        vm.configdateTimePickerEnd.maxDate = new Date(
          eventEndTimestamp * 1000
        );
        if (vm.currentSessionId) {
          vm.configdateTimePickerStart.minDate = new Date(
            res.data.StartDateSeconds * 1000
          );
          if (vm.configdateTimePickerStart.minDate > new Date()) {
            vm.configdateTimePickerStart.minDate = new Date();
          }
          vm.configdateTimePickerEnd.minDate = new Date(
            res.data.EndDateSeconds * 1000
          );
          if (vm.configdateTimePickerEnd.minDate > new Date()) {
            vm.configdateTimePickerEnd.minDate = new Date();
          }
        } else {
          let currentTimestamp = parseInt(new Date().getTime() / 1000);
          if (currentTimestamp > eventStartTimestamp) {
            vm.configdateTimePickerStart.minDate = new Date(
              currentTimestamp * 1000
            );
            vm.configdateTimePickerEnd.minDate = new Date(
              currentTimestamp * 1000
            );
          }          
          if (currentTimestamp > eventEndTimestamp) {
            vm.showSnackbar("As the event already ended, Session can't be created.", "error", "top");
            return;
          }
        }
        vm.session_data = res.data;
        //vm.sessionAddEditDialog = true;
        vm.sessionDialog = true;
        vm.sessionAddEditKey++;
      }
      // this.$nextTick(() => {
      //   // $("#sessionAddEdit").modal("show");
      //   vm.sessionDialog= true
      // });
    },
    CloseAddSessionPopup() {
      vm.sessionAddEditKey++;
      vm.sessionAddEditDialog = false;
      $("#sessionAddEdit").modal("hide");
    },
    OnAddSessionSuccess() {
      vm.CloseAddSessionPopup();
      vm.OpenSuccess();
    },
    OpenSuccess() {
      $("#sessionAddEditSuccess").modal("show");
    },
    CloseSuccess() {
      $("#sessionAddEditSuccess").modal("hide");
      vm.sessionsListKey++;
    },
    fetchSession(id) {
      return new Promise((resolve, reject) => {
        if (!id) {
          resolve({
            status: 200,
            data: {
              Description: "",
              DescriptionShort: "",
              StartDate: new Date(),
              EndDate: new Date(new Date().getTime() + 5 * 60000),
              Resources: [],
              Location: { LocationID: 0, LocationName: "" },
              MappedSpeakers: [],
              MappedHosts: [],
              MappedCoHost: null,
              Name: "",
              SessionLogo:
                "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2Fon-air-white.png?alt=media",
              //StreamingClient: vm.createSessionTypeId == 3 ? "Zoom" : "Web",
              StreamingClient: "Web",
              approval_type: 2,
              IsZoomRTMP: true,
              WebinarCapacity: null,
              SpeakersJoinZoomWebSDK: false,
              SessionSettings: { PostRollImageURL: "", PreRollImageURL: "" },
              Track: {
                TrackID: "",
                TrackName: "",
              },
              PlayerControl: true,
              EnableGroupChat: true,
              ShowAttendeeList: true,
              EnableBottomBar: false,
              PhotoWallAlbum: null,
              EmbedCode: null,
              Active: "PhotoWallAlbum",
              ODVideoURL: null,
              ODVideoLengthMinutes: null,
              LSDateTime: null,
              LSVideoURL: null,
              IsManualUrl: false,
              RTMPURL: null,
              StreamKey: null,
              LSVideoURLType: "LSVideoURL",
              LSVideoLengthMinutes: null,
              SessionTypeDetails: {
                TypeID: vm.createSessionTypeId,
                TypeName: vm.createSessionTypeName,
              },
              LivePanel: true,
              QnAModeration: false,
              AllowPostingQuestionsAnonymously: false,
              ConvertToOnDemandVideoOnSessionEnd: true,
              QnAAutoPublish: false,
              EnableHelpORSettings: false,
              EnableLiveQnA: false,
              EnableRaiseHand: false,
              ShowAgenda: false,
              ShowSpeakerList: true,
              AudiencePoll: false,
              RoundTables: null,
              MapExistingRoundTableGroup: false,
              RTStreamingClient: "Zoom",
              Spectate: false,
              TableType: "Open",
              RTHost: null,
              NumberOfSeatsPerTable: 8,
              NumberOfTables: 1,
              Imperson: false,
              InPersonIcon: null,
              InPersonLabel: null,
              InPersonURL: null,
              IsPublished: true,
              SessionVisibleFor: { label: "Everyone", value: 1 },
              ShowSessionStartNotificationMessage: false,
              DisplayBeforeSessionStartMin: 5,
              DisplayBeforeSessionStartMin_Secondary: 120,
              DisplayBeforeSessionStart_Hour: 12,
              StartNotificationSendTo: "Email",
              StartNotificationSendToThird: "EmailOnly",
              StartNotificationMessage:
                "Dear {{FirstName}} this is a gentle reminder that {{SessionName}} of {{EventName}} will begin in {{CountDownTime}}. Date: {{StartDate}} to {{EndDate}}.",
              DisplayBeforeSessionEndSecs: 60,
              ShowSessionEndNotificationMessage: true,
              NotificationMessage:
                "This session is about to end in {{countdown}}",
            },
          });
        } else {
          let docObj = new Object();
          db.collection(vm.event_collectionName)
            .doc("SessionList")
            .collection("Sessions")
            .doc(`${id}`)
            .get()
            .then(function (doc) {
              docObj = doc.data();
              // docObj.StreamingClient = doc.data().StreamingClient
              //   ? doc.data().StreamingClient
              //   : "Web";
              docObj.StreamingClient = "Web";
              docObj.approval_type =
                doc.data().approval_type != undefined
                  ? doc.data().approval_type
                  : 0;
              docObj.MappedHosts =
                doc.data().StreamingClient == "Zoom"
                  ? [doc.data().MappedHosts[0]]
                  : doc.data().MappedHosts;
              docObj.MappedCoHost = doc.data().MappedCoHost
                ? doc.data().MappedCoHost
                : null;
              docObj.IsZoomRTMP = doc.data().IsZoomRTMP
                ? doc.data().IsZoomRTMP
                : false;
              docObj.IsRTMP = doc.data().IsRTMP ? doc.data().IsRTMP : false;
              docObj.WebinarCapacity = doc.data().WebinarCapacity
                ? doc.data().WebinarCapacity
                : null;
              docObj.SpeakersJoinZoomWebSDK = doc.data().SpeakersJoinZoomWebSDK
                ? doc.data().SpeakersJoinZoomWebSDK
                : false;
              docObj.StartDate = doc.data().StartDate
                ? new Date(doc.data().StartDate.seconds * 1000).toUTCString()
                : null;
              docObj.StartDateSeconds = doc.data().StartDate
                ? doc.data().StartDate.seconds
                : parseInt(new Date().getTime() / 1000);
              docObj.EndDate = doc.data().EndDate
                ? new Date(doc.data().EndDate.seconds * 1000).toUTCString()
                : null;
              docObj.EndDateSeconds = doc.data().EndDate
                ? doc.data().EndDate.seconds
                : parseInt(new Date().getTime() / 1000) + 300;
              let SessionTypeDetails = doc.data().SessionTypeDetails;
              docObj.TypeID = SessionTypeDetails.TypeID
                ? SessionTypeDetails.TypeID
                : 3;
              docObj.IsManualUrl = false;
              docObj.ShowSpeakerList =
                SessionTypeDetails.ShowSpeakerList != undefined
                  ? SessionTypeDetails.ShowSpeakerList
                  : true;
              docObj.AudiencePoll =
                SessionTypeDetails.AudiencePoll != undefined
                  ? SessionTypeDetails.AudiencePoll
                  : false;
              docObj.ShowAgenda =
                SessionTypeDetails.ShowAgenda != undefined
                  ? SessionTypeDetails.ShowAgenda
                  : false;
              docObj.EnableRaiseHand =
                SessionTypeDetails.EnableRaiseHand != undefined
                  ? SessionTypeDetails.EnableRaiseHand
                  : false;
              docObj.EnableLiveQnA =
                SessionTypeDetails.EnableLiveQnA != undefined
                  ? SessionTypeDetails.EnableLiveQnA
                  : false;
              docObj.EnableHelpORSettings =
                SessionTypeDetails.EnableHelpORSettings != undefined
                  ? SessionTypeDetails.EnableHelpORSettings
                  : false;
              docObj.PlayerControl =
                SessionTypeDetails.PlayerControl != undefined
                  ? SessionTypeDetails.PlayerControl
                  : true;
              docObj.EnableGroupChat =
                SessionTypeDetails.EnableGroupChat != undefined
                  ? SessionTypeDetails.EnableGroupChat
                  : true;
              docObj.ShowAttendeeList =
                SessionTypeDetails.ShowAttendeeList != undefined
                  ? SessionTypeDetails.ShowAttendeeList
                  : true;
              docObj.EnableBottomBar =
                SessionTypeDetails.EnableBottomBar != undefined
                  ? SessionTypeDetails.EnableBottomBar
                  : false;
              docObj.PhotoWallAlbum =
                SessionTypeDetails.PhotoWallAlbum != undefined
                  ? SessionTypeDetails.PhotoWallAlbum
                  : null;
              docObj.EmbedCode = SessionTypeDetails.EmbedCode
                ? SessionTypeDetails.EmbedCode
                : null;
              docObj.Active = SessionTypeDetails.Active
                ? SessionTypeDetails.Active
                : "PhotoWallAlbum";
              docObj.ODVideoURL =
                SessionTypeDetails.TypeID == 1
                  ? SessionTypeDetails.VideoURL
                  : null;
              docObj.ODVideoLengthMinutes =
                SessionTypeDetails.TypeID == 1
                  ? SessionTypeDetails.VideoLengthMinutes
                  : null;
              docObj.LSDateTime =
                SessionTypeDetails.TypeID == 2 &&
                SessionTypeDetails.StartDateTime
                  ? new Date(
                      SessionTypeDetails.StartDateTime.seconds * 1000
                    ).toUTCString()
                  : null;
              docObj.LSVideoURL =
                SessionTypeDetails.TypeID == 2
                  ? SessionTypeDetails.LiveStreamURL
                  : null;
              docObj.RTMPURL =
                SessionTypeDetails.TypeID == 2
                  ? SessionTypeDetails.RTMPURL
                  : null;
              docObj.StreamKey =
                SessionTypeDetails.TypeID == 2
                  ? SessionTypeDetails.StreamKey
                  : null;
              docObj.LSVideoURLType =
                SessionTypeDetails.TypeID == 2 && SessionTypeDetails.RTMPURL
                  ? "RTMPURL"
                  : "LSVideoURL";
              docObj.LSVideoLengthMinutes =
                SessionTypeDetails.TypeID == 2
                  ? SessionTypeDetails.StreamLengthMinutes
                  : null;
              docObj.LivePanel = SessionTypeDetails.TypeID == 3 ? true : false;
              docObj.QnAModeration =
                SessionTypeDetails.QnAModeration != undefined
                  ? SessionTypeDetails.QnAModeration
                  : false;
              docObj.AllowPostingQuestionsAnonymously =
                SessionTypeDetails.AllowPostingQuestionsAnonymously != undefined
                  ? SessionTypeDetails.AllowPostingQuestionsAnonymously
                  : false;
              docObj.ConvertToOnDemandVideoOnSessionEnd =
                SessionTypeDetails.ConvertToOnDemandVideoOnSessionEnd !=
                undefined
                  ? SessionTypeDetails.ConvertToOnDemandVideoOnSessionEnd
                  : true;
              docObj.QnAAutoPublish =
                SessionTypeDetails.QnAAutoPublish != undefined
                  ? SessionTypeDetails.QnAAutoPublish
                  : false;
              /************ ROUND TABLE *******/
              if (
                SessionTypeDetails.TypeID == 4 &&
                SessionTypeDetails.RoundTableTopic
              ) {
                docObj.RoundTables = {
                  TopicId: SessionTypeDetails.RoundTableTopic.TopicId,
                  TopicName: SessionTypeDetails.RoundTableTopic.TopicName,
                  TopicDisplayName:
                    SessionTypeDetails.RoundTableTopic.TopicDisplayName,
                  TopicTableCapacity:
                    SessionTypeDetails.RoundTableTopic.TopicTableCapacity,
                };
              } else docObj.RoundTables = [];
              docObj.MapExistingRoundTableGroup =
                SessionTypeDetails.TypeID == 4 &&
                SessionTypeDetails.MapExistingRoundTableGroup != undefined
                  ? SessionTypeDetails.MapExistingRoundTableGroup
                  : true;
              docObj.RTStreamingClient =
                SessionTypeDetails.TypeID == 4 &&
                SessionTypeDetails.RTStreamingClient
                  ? SessionTypeDetails.RTStreamingClient
                  : "Web";
              //docObj.Spectate = (SessionTypeDetails.TypeID == 4 && SessionTypeDetails.SpectatorEnabled ? SessionTypeDetails.SpectatorEnabled != undefined : true)
              docObj.Spectate = false;
              docObj.TableType =
                SessionTypeDetails.TypeID == 4 && SessionTypeDetails.TableType
                  ? SessionTypeDetails.TableType
                  : "Open";
              docObj.RTHost =
                SessionTypeDetails.TypeID == 4 && SessionTypeDetails.RTHost
                  ? SessionTypeDetails.RTHost
                  : null;
              docObj.NumberOfSeatsPerTable =
                SessionTypeDetails.TypeID == 4 &&
                SessionTypeDetails.NumberOfSeatsPerTable
                  ? SessionTypeDetails.NumberOfSeatsPerTable
                  : 8;
              docObj.NumberOfTables =
                SessionTypeDetails.TypeID == 4 &&
                SessionTypeDetails.NumberOfTables
                  ? SessionTypeDetails.NumberOfTables
                  : 1;
              /************ ROUND TABLE *******/
              docObj.Imperson = SessionTypeDetails.TypeID == 5 ? true : false;
              docObj.InPersonIcon =
                SessionTypeDetails.TypeID == 5 &&
                SessionTypeDetails.InPersonIcon
                  ? SessionTypeDetails.InPersonIcon
                  : null;
              docObj.InPersonLabel =
                SessionTypeDetails.TypeID == 5 &&
                SessionTypeDetails.InPersonLabel
                  ? SessionTypeDetails.InPersonLabel
                  : null;
              docObj.InPersonURL =
                SessionTypeDetails.TypeID == 5 && SessionTypeDetails.InPersonURL
                  ? SessionTypeDetails.InPersonURL
                  : null;
              docObj.SessionVisibleFor = docObj.SessionVisibleFor
                ? docObj.SessionVisibleFor
                : { label: "Everyone", value: 1 };

              docObj.Resources = doc.data().Resources
                ? doc.data().Resources
                : [];
              docObj.IsPublished =
                docObj.IsPublished == undefined ? false : docObj.IsPublished;
              docObj.DisplayBeforeSessionEndSecs =
                docObj.DisplayBeforeSessionEndSecs
                  ? docObj.DisplayBeforeSessionEndSecs
                  : 60;
              docObj.ShowSessionEndNotificationMessage =
                docObj.ShowSessionEndNotificationMessage != undefined
                  ? docObj.ShowSessionEndNotificationMessage
                  : true;
              docObj.NotificationMessage = docObj.NotificationMessage
                ? docObj.NotificationMessage
                : "This session is about to end in {{countdown}}";
              docObj.DisplayBeforeSessionStartMin =
                docObj.DisplayBeforeSessionStartMin != undefined
                  ? docObj.DisplayBeforeSessionStartMin
                  : 5;
              docObj.DisplayBeforeSessionStartMin_Secondary =
                docObj.DisplayBeforeSessionStartMin_Secondary != undefined
                  ? docObj.DisplayBeforeSessionStartMin_Secondary
                  : 120;
              docObj.DisplayBeforeSessionStart_Hour =
                docObj.DisplayBeforeSessionStart_Hour != undefined
                  ? docObj.DisplayBeforeSessionStart_Hour
                  : 12;
              docObj.ShowSessionStartNotificationMessage =
                docObj.ShowSessionStartNotificationMessage != undefined
                  ? docObj.ShowSessionStartNotificationMessage
                  : false;
              docObj.StartNotificationSendTo =
                docObj.StartNotificationSendTo != undefined
                  ? docObj.StartNotificationSendTo
                  : "Email";
              docObj.StartNotificationSendToThird =
                docObj.StartNotificationSendToThird != undefined
                  ? docObj.StartNotificationSendToThird
                  : "EmailOnly";
              docObj.StartNotificationMessage = docObj.StartNotificationMessage
                ? docObj.StartNotificationMessage
                : null;
              //console.log(SessionTypeDetails)
              resolve({ status: 200, data: docObj });
            })
            .catch(function (error) {
              //console.log('Error getting mapped session:', error)
              reject(error);
            });
        }
      });
    },
    getAllActiveSpeakers() {
      vm.speakerList = [];
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${vm.getSessionToken()}`,
          instanceId: "OA_UAT",
          clientId: vm.getClientId(),
          eventId: vm.getEventId(),
        };
        axios
          .get(APIs.speakerList, { headers: headers })
          .then(function (res) {
            let speakers = [];
            if (res.data.status == 0 && res.data.results.length) {
              for (let item of res.data.results) {
                if (item.IsPublished) {
                  vm.speakerList.push({
                    AttendeeId: item.SpeakerId,
                    Company: item.Company,
                    Designation: item.Designation,
                    Email: item.Email,
                    FirstName: item.FirstName,
                    LastName: item.LastName,
                    Name: item.Name,
                    Phone: item.Phone,
                    ProfilePictureURL: item.ProfilePictureURL
                      ? item.ProfilePictureURL
                      : "",
                  });
                }
              }
            }
            resolve(speakers);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAllActiveAttendees() {
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${vm.getSessionToken()}`,
        };
        let requestData = {
          key: {
            instanceId: "OA_UAT",
            clientId: vm.getClientId(),
            eventId: vm.getEventId(),
          },
          data: {
            search: [],
            filter: [
              {
                key: "IsPublished",
                operator: "==",
                value: true,
              },
            ],
            sort: { sortBy: "FirstName", sortOrder: "asc" },
            pagination: {
              Page: 1,
              PageSize: 9999,
            },
            origin: "COMPACT",
          },
        };
        axios
          .post(APIs.AttendeeSearch, requestData, { headers: headers })
          .then(function (res) {
            let attendees = [];
            if (res.data.status == 0 && res.data.result.length) {
              attendees = res.data.result;
            }
            vm.attendeeList = attendees;
            resolve(attendees);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAllRtTopic() {
      vm.roundtableGroupList = [];
      return new Promise((resolve, reject) => {
        let headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${vm.getSessionToken()}`,
          instanceId: "OA_UAT",
          clientId: vm.getClientId(),
          eventId: vm.getEventId(),
        };
        axios
          .get(APIs.GetAllRtTopic, { headers: headers })
          .then(function (res) {
            let roundtableGroupList = [];
            if (res.data.status == 0 && res.data.results.length) {
              for (let item of res.data.results) {
                vm.roundtableGroupList.push({
                  TopicId: item.TopicId,
                  TopicName: item.TopicName.trim(),
                  TopicDisplayName:
                    item.TopicName.trim() +
                    " (" +
                    (item.TableCapacity == undefined
                      ? 12
                      : item.TableCapacity) +
                    ")",
                  TopicTableCapacity:
                    item.TableCapacity === undefined ? 12 : item.TableCapacity,
                });
              }
            }
            resolve(roundtableGroupList);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GetTimeByZone: function (strDateTime, timeZone) {
      strDateTime = moment(strDateTime).format("YYYY-MM-DD HH:mm");
      var strtDate = moment.tz(strDateTime, timeZone);
      strtDate._d.setMinutes(strtDate._d.getMinutes() - strtDate._offset);
      return strtDate._d;
    },
    createSession() {

      console.log("cs=====", this.session_data);
       if (
        !this.session_data.Name
      ) {
        vm.showSnackbar("Title cannot be empty", "error", "top");
        return;
      }

      if (
        this.session_data.SessionTypeDetails.TypeID == 5 &&
        this.session_data.MappedHosts.length == 0
      ) {
        vm.showSnackbar("Host cannot be empty", "error", "top");
        return;
      }

      if (
        this.session_data.SessionTypeDetails.TypeID == 3 &&
        (this.session_data.MappedHosts.length == 0 ||
          this.session_data.MappedSpeakers.length == 0)
      ) {
        vm.showSnackbar("Host/Speaker cannot be empty", "error", "top");
        return;
      }
      if (!this.session_data.StartDate || !this.session_data.EndDate) {
        vm.showSnackbar("Start/End date cannot be empty", "error", "top");
        return;
      }

      this.$refs.form.validate();
      bus.$emit("toggleLoader", true);
      this.sessionDialog = false;
      let StartDate = this.GetTimeByZone(
        this.session_data.StartDate,
        store.getters.getZone
      );
      let EndDate = this.GetTimeByZone(
        this.session_data.EndDate,
        store.getters.getZone
      );
      let docObj = {
        SessionId: 0,
        Description: this.session_data.Description,
        DescriptionShort: this.session_data.DescriptionShort,
        StartDate: this.session_data.StartDate ? StartDate : null,
        EndDate: this.session_data.EndDate ? EndDate : null,
        Timezone: store.getters.getZone,
        DisplayBeforeSessionEndSecs: this.session_data
          .DisplayBeforeSessionEndSecs
          ? this.session_data.DisplayBeforeSessionEndSecs
          : 60,
        ShowSessionEndNotificationMessage:
          this.session_data.ShowSessionEndNotificationMessage != undefined
            ? this.session_data.ShowSessionEndNotificationMessage
            : true,
        NotificationMessage: this.session_data.NotificationMessage
          ? this.session_data.NotificationMessage
          : null,
        StartNotificationMessage:
          "Dear {{FirstName}} this is a gentle reminder that {{SessionName}} of {{EventName}} will begin in {{CountDownTime}}. Date: {{StartDate}} to {{EndDate}}.",
        Location: this.session_data.Location,
        MappedSpeakers: this.session_data.MappedSpeakers,
        MappedHosts: this.session_data.MappedHosts,
        MappedCoHost:
          this.session_data.StreamingClient == "Web"
            ? this.session_data.MappedCoHost
            : null,
        Name: this.session_data.Name.trim(),
        IsPublished: this.session_data.IsPublished,
        SessionSettings: this.session_data.SessionSettings,
        SessionVisibleFor: this.session_data.SessionVisibleFor,
        Resources: [],
        StreamingClient: this.session_data.StreamingClient,
        approval_type: this.session_data.approval_type,
        IsZoomRTMP:
          this.session_data.SessionTypeDetails.TypeID == 3
            ? this.session_data.IsZoomRTMP
            : false,
        WebinarCapacity: this.session_data.WebinarCapacity,
        SpeakersJoinZoomWebSDK: this.session_data.SpeakersJoinZoomWebSDK,
        Track: this.session_data.Track,
        Batch: null,
        SessionLogo: this.session_data.SessionLogo,
      };
      if (vm.currentSessionId) {
        docObj.SessionId = vm.currentSessionId;
      }
      if (this.session_data.SessionTypeDetails.TypeID == 3) {
        docObj.SessionTypeDetails = {
          TypeID: 3,
          TypeName: "Live Panel",
          QnAModeration: this.session_data.QnAModeration,
          AllowPostingQuestionsAnonymously:
            this.session_data.AllowPostingQuestionsAnonymously,
          ConvertToOnDemandVideoOnSessionEnd:
            this.session_data.ConvertToOnDemandVideoOnSessionEnd,
          QnAAutoPublish: this.session_data.QnAAutoPublish,
          EnableHelpORSettings: this.session_data.EnableHelpORSettings,
          EnableLiveQnA: this.session_data.EnableLiveQnA,
          EnableRaiseHand: this.session_data.EnableRaiseHand,
          ShowAgenda: this.session_data.ShowAgenda,
          ShowAttendeeList: this.session_data.ShowAttendeeList,
          ShowSpeakerList: this.session_data.ShowSpeakerList,
          AudiencePoll: this.session_data.AudiencePoll,
          EnableGroupChat: this.session_data.EnableGroupChat,
        };
      } else if (this.session_data.SessionTypeDetails.TypeID == 4) {
        docObj.SessionTypeDetails = {
          TypeID: 4,
          TypeName: "Round Table",
          RoundTableTopic: this.session_data.RoundTables,
          MapExistingRoundTableGroup:
            this.session_data.MapExistingRoundTableGroup != undefined
              ? this.session_data.MapExistingRoundTableGroup
              : true,
          RTStreamingClient: this.session_data.RTStreamingClient
            ? this.session_data.RTStreamingClient
            : "Web",
          Spectate: false,
          PreAssigned:
            this.session_data.TableType == "Pre_assigned" ? true : false,
          RTHost: this.session_data.RTHost ? this.session_data.RTHost : null,
          NumberOfSeatsPerTable: this.session_data.NumberOfSeatsPerTable
            ? this.session_data.NumberOfSeatsPerTable
            : 0,
          NumberOfTables: this.session_data.NumberOfTables
            ? this.session_data.NumberOfTables
            : 0,
        };
      } else if (this.session_data.SessionTypeDetails.TypeID == 5) {
        docObj.SessionTypeDetails = {
          TypeID: 5,
          TypeName: "In-Person",
          InPersonIcon: null,
          InPersonLabel: null,
          InPersonURL: null,
        };
      }
      let accessToken = vm.getSessionToken();
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.getClientId(),
          eventId: vm.getEventId(),
        },
        data: docObj,
      };
      if (vm.currentSessionId) {
        axios
          .put(APIs.AddSession, requestData, { headers: headers })
          .then(function (res) {
            console.log(res);
            bus.$emit("toggleLoader", false);
            if (res.data.status == 0) {
              vm.$refs.sessionList.getSessions();
              vm.showSnackbar(
                "Session Updated Successfully.",
                "success",
                "top"
              );
            } else {
              vm.showSnackbar("Unable To Update Session!", "warning", "top");
            }
          })
          .catch(() => {
            bus.$emit("toggleLoader", false);
            vm.showSnackbar("Something Went Wrong!", "warning", "top");
          });
      } else {
        axios
          .post(APIs.AddSession, requestData, { headers: headers })
          .then(function (res) {
            console.log(res);
            bus.$emit("toggleLoader", false);
            if (res.data.status == 0) {
              vm.$refs.sessionList.getSessions();
              vm.showSnackbar(
                "Session Created Successfully.",
                "success",
                "top"
              );
            } else {
              vm.showSnackbar("Unable To Create Session!", "warning", "top");
            }
          })
          .catch(() => {
            bus.$emit("toggleLoader", false);
            vm.showSnackbar("Something Went Wrong!", "warning", "top");
          });
      }
    },
    update_logo(input, fileWH, uploadedField) {
      // You can update avatar Here
      //console.log(vm.$refs.regV3.EventsData[0].EventLogo)
      if (input) {
        let file = input;
        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = fileWH.split("x");
        let uploadTargetPath = `${vm.getEventCollectionName()}/Session/LogoImage/`;
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if (this.width >= dimension[0] && this.height >= dimension[1]) {
            const reader = new FileReader();
            reader.onload = (e) => {
              let fileBlob = e.target.result;
              //vm.$refs.regV3.EventsData[0].EventLogo = fileBlob;
              vm.uploadServerImage(
                fileBlob,
                uploadTargetPath,
                file,
                uploadedField
              );
            };
            reader.readAsDataURL(file);
          } else {
            alert("Please upload a banner " + fileWH + " px");
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadServerImage(fileBlob, target, file, uploadedField) {
      bus.$emit("toggleLoader", true);
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${vm.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.getClientId(),
          eventId: vm.getEventId(),
        },
        files: [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ],
      };
      axios
        .post(APIs.UploadFiles, requestData, { headers: headers })
        .then(function (res) {
          bus.$emit("toggleLoader", false);
          if (
            res.data.status == 0 &&
            res.data.data.length &&
            res.data.data[0].status == "fulfilled"
          ) {
            vm[uploadedField.field][uploadedField.key] =
              res.data.data[0].value.url;
          } else vm.showSnackbar("Unable to upload!", "error", "top");
        })
        .catch(() => {
          bus.$emit("toggleLoader", false);
          vm.showSnackbar("Something went wrong!", "error", "top");
        });
    },
    changeSessionStatus(sessionId, isPublished) {
      let docObj = {
        SessionId: sessionId,
        IsPublished: isPublished,
      };
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${vm.getSessionToken()}`,
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.getClientId(),
          eventId: vm.getEventId(),
        },
        data: docObj,
      };
      axios
        .put(APIs.AddSession, requestData, { headers: headers })
        .then(function (res) {
          var success = false;
          if (res.data.status == 0) {
            success = true;
          }
          vm.$refs.sessionList.onChangeSessionStatusSuccess(
            sessionId,
            isPublished,
            success
          );
          vm.mapSessionAttendeeStatusChange(sessionId, isPublished).then(
            (res) => {
              console.log(res);
              return { status: 200, message: "Data Updated." };
            }
          );
        })
        .catch(function (error) {
          console.log(error);
          vm.$refs.sessionList.onChangeSessionStatusSuccess(
            sessionId,
            isPublished,
            false
          );
        });
    },
    mapSessionAttendeeStatusChange(sessionId, isPublished) {
      return new Promise((resolve) => {
        let headers = {
          "content-type": "application/json",
          Authorization: `Bearer ${vm.getSessionToken()}`,
        };
        let requestData = {
          source: "web",
          key: {
            instanceId: "OA_UAT",
            clientId: vm.getClientId(),
            eventId: vm.getEventId(),
          },
          data: {
            sessions: [{ SessionId: sessionId }],
            value: {
              IsPublished: isPublished,
            },
          },
        };
        //console.log(requestData)
        axios
          .put(APIs.SessionAttendeeMappingAPI, requestData, {
            headers: headers,
          })
          .then((response) => {
            console.log(response);
            debugger;
            resolve({ status: 200, message: "Status Changed" });
          })
          .catch((error) => {
            console.log(error);
            debugger;
            resolve({ status: 500, message: "Status Not Changed" });
          });
      });
    },
    deleteSession(sessionId) {
      let sessions = [
        {
          SessionId: sessionId,
        },
      ];
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.getClientId(),
          eventId: vm.getEventId(),
        },
        data: {
          sessions: sessions,
        },
      };
      axios
        .delete(APIs.SessionAttendeeMappingAPI, {
          data: requestData,
          headers: headers,
        })
        .then(function (res) {
          var success = false;
          if (res.data.status == 0) {
            success = true;
          }
          vm.$refs.sessionList.onDeleteSessionSuccess(sessionId, success);
        })
        .catch(function (error) {
          console.log(error);
          vm.$refs.sessionList.onDeleteSessionSuccess(sessionId, false);
        });
    },
  },
};
</script>
